import React from "react";
import api from "../lib/api";
import Lightbox from "../components/Lightbox";
import Grain from "../components/Grain";
import { usePublicData } from "../lib/publicData";
import { portfolioAlt } from '../lib/portfolioAlt';

const CATEGORIES = [
  { key: "all", label: "Tout" },
  { key: "celebrations", label: "Célébrations" },
  { key: "maternite", label: "Maternité" },
  { key: "portrait", label: "Portrait" },
  { key: "branding", label: "Branding" },
  { key: "studio", label: "Studio" },
  { key: "atelier-lumiere", label: "Atelier Lumière" },
];

export default function Portfolio() {
  const initial = usePublicData();
  const [images, setImages] = React.useState(initial.portfolio || []);
  const [cat, setCat] = React.useState("all");
  const [lightboxIndex, setLightboxIndex] = React.useState(null);

  React.useEffect(() => {
    const params = cat === "all" ? {} : { category: cat };
    api.get("/portfolio", { params }).then((r) => setImages(r.data)).catch(()=>{});
  }, [cat]);

  return (
    <div className="pt-28 section-dark min-h-screen">
      <section className="px-6 md:px-12 py-12 md:py-20 relative overflow-hidden" data-testid="portfolio-hero">
        <Grain />
        <div className="absolute -top-20 right-1/4 w-[500px] h-[500px] glow-amber-soft pointer-events-none" />
        <div className="max-w-[1480px] mx-auto relative z-10">
          <div className="eyebrow mb-4">Portfolio</div>
          <h1 className="h-display text-6xl md:text-8xl">Le <span className="italic-accent">travail.</span></h1>
        </div>
      </section>

      <section className="px-6 md:px-12 pb-6" data-testid="portfolio-filters">
        <div className="max-w-[1480px] mx-auto flex flex-wrap gap-x-8 gap-y-3 border-b border-white/10 pb-6">
          {CATEGORIES.map((c) => (
            <button
              key={c.key}
              onClick={() => setCat(c.key)}
              data-testid={`filter-${c.key}`}
              aria-pressed={cat === c.key}
              className={`eyebrow transition ${cat === c.key ? "text-accent-light" : "text-text-cream/40 hover:text-text-cream"}`}
            >
              {c.label}
            </button>
          ))}
        </div>
      </section>

      <section className="px-6 md:px-12 pb-32" data-testid="portfolio-grid">
        <div className="max-w-[1480px] mx-auto">
          {images.length === 0 ? (
            <div className="text-center text-text-cream/40 py-24 font-serif italic text-2xl">Aucune image dans cette catégorie.</div>
          ) : (
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 mt-8">
              {images.map((img, i) => (
                <button
                  key={img.id}
                  data-testid={`portfolio-image-${img.id}`}
                  aria-label={`Agrandir : ${portfolioAlt(img)}`}
                  onClick={() => setLightboxIndex(i)}
                  className={`relative overflow-hidden hover-zoom group ${i % 7 === 0 ? "md:row-span-2 aspect-[3/4] md:aspect-[3/5]" : "aspect-[4/5]"}`}
                >
                  <img src={img.url} alt={portfolioAlt(img)} loading="lazy" className="w-full h-full object-cover" />
                  <div className="absolute inset-0 bg-dark/0 group-hover:bg-dark/20 transition" />
                </button>
              ))}
            </div>
          )}
        </div>
      </section>

      {lightboxIndex !== null && (
        <Lightbox
          images={images}
          index={lightboxIndex}
          onClose={() => setLightboxIndex(null)}
          onPrev={() => setLightboxIndex((i) => (i - 1 + images.length) % images.length)}
          onNext={() => setLightboxIndex((i) => (i + 1) % images.length)}
        />
      )}
    </div>
  );
}
